import { SquareOnlineStoreProjectType } from '__generated__/types';

interface ProjectType {
    title: string;
    description: string;
    price: number;
}

export const projectTypes: { [key in SquareOnlineStoreProjectType]: ProjectType } = {
    [SquareOnlineStoreProjectType.NEW_SITE]: {
        title: __('Create a new Square Online Store'),
        price: 45000,
        description: __(
            'A Square Online Expert can get your Store online so you can stay focused on running your business'
        ),
    },
    [SquareOnlineStoreProjectType.RECREATE_SITE]: {
        title: __('Migrate to Square Online Store'),
        price: 45000,
        description: __(
            'Migrate your existing website and simplify all aspects of your business. Keep online and in-person orders, items, and inventory in sync, and all in one place'
        ),
    },
    [SquareOnlineStoreProjectType.MINOR_CHANGES]: {
        title: __('Update your Square Online Store'),
        price: 5000,
        description: __(
            'Keep your store looking fresh and take advantage of all the advanced eCommerce features available to you through Square Online Store'
        ),
    },
    [SquareOnlineStoreProjectType.MAJOR_CHANGES]: {
        title: __('Redesign your Square Online Store'),
        price: 45000,
        description: __(
            'Does your Online Store need a new lick of paint? Our experts are professional designers and have all the skills to help guide you through the process so you can look fresh'
        ),
    },
};
